import styled, { css } from "styled-components";

export enum SizeBanner {
    sm = "small",
    md = "medium",
}

export const AdBannerRoot = styled.div(
    () => css`
        width: 100%;
        aspect-ratio: 1000 / 311;
        background-color: #FFFFFF;
        border-radius: 18px;
        cursor: pointer;
        box-shadow: 0px 3px 5px #00000029;
        overflow: hidden;
    `,
);

export const AdBannerImage = styled.img(
    () => css`
        width: 100%;
        height: 100%;
        object-fit: fill;
    `,
);
